import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  setFilters,
  clearFilters,
  getSearchResultsMap,
} from "../../../actions/restaurantActions";
import SearchBar from "./SearchBar";
import FilteringStyles from "../../../styles/FilteringStyles";
import DownArrow from "../../icons/DownArrow";
import CloseIcon from "../../icons/CloseIcon";

const SearchSortFilter = ({
  city,
  restaurants,
  setFilters,
  clearFilters,
  getSearchResultsMap,
  history,
  mobile,
  toggleFilterTakeover,
  numOfFilters,
  numOfFiltersText,
  mapView,
}) => {
  // useEffect(() => {
  //   clearAllChecks();
  // }, []);

  const {
    lifestyleFilter,
    mealFilter,
    cuisineFilter,
    priceFilter,
    neighborhoodFilter,
    diningFilter,
    vibeFilter,
    restaurantList,
  } = restaurants;

  const saveChanges = e => {
    if (typeof window !== `undefined`) {
      history.search = null;

      const dropdownList = e.currentTarget.classList[0].split("-")[0];

      const filterArray = [];
      const list = document.getElementsByClassName(`${dropdownList}-check`);
      for (let item of list) {
        if (item.checked === true) {
          filterArray.push(item.name);
        }
      }

      // define filter type
      let filterType;
      if (dropdownList === "sustainable") {
        filterType = "consciousFilter";
      } else {
        filterType = `${dropdownList}Filter`;
      }

      if (filterType === "consciousFilter") {
        setFilters({ [filterType]: filterArray }, history, restaurants);
      }

      if (filterType === "cuisineFilter") {
        setFilters({ [filterType]: filterArray }, history, restaurants);
      }

      if (filterType === "diningFilter") {
        setFilters({ [filterType]: filterArray }, history, restaurants);
      }

      if (filterType === "mealFilter") {
        setFilters({ [filterType]: filterArray }, history, restaurants);
      }

      if (filterType === "lifestyleFilter") {
        setFilters({ [filterType]: filterArray }, history, restaurants);
      }

      if (filterType === "priceFilter") {
        setFilters({ [filterType]: filterArray }, history, restaurants);
      }

      if (filterType === "vibeFilter") {
        setFilters({ [filterType]: filterArray }, history, restaurants);
      }

      if (filterType === "neighborhoodFilter") {
        setFilters({ [filterType]: filterArray }, history, restaurants);
      }

      //if mobile, scroll to top of results.
      if (
        window.matchMedia("(pointer: coarse)").matches ||
        window.matchMedia("(hover: none)").matches
      ) {
        setTimeout(function () {
          const targetElement = document.querySelector(".num-of-results-text");
          if (targetElement)
            targetElement.scrollIntoView({ block: "start", inline: "start" });
        }, 500);
      } else {
        const targetResults = document.querySelector(".results");
        // if (targetResults) targetResults.scrollIntoView(true);

        const targetElement = document.querySelector(".restaurant-list");
        if (targetElement) targetElement.scrollTop = 0;
      }
    }
  };

  function clearAllChecks() {
    if (typeof window !== `undefined`) {
      const dropdownArray = [
        ".sustainable-check",
        ".lifestyle-check",
        ".vibe-check",
        ".cuisine-check",
        ".meal-check",
        ".dining-check",
        ".neighborhood-check",
        ".price-check",
      ];

      dropdownArray.forEach(dropdown => {
        const dropdownChecks = document.querySelectorAll(dropdown);
        const dropdownChecksArray = Array.from(dropdownChecks);
        dropdownChecksArray.forEach(check => (check.checked = false));
      });
    }
  }

  const seeAll = () => {
    if (typeof window !== `undefined`) {
      clearAllChecks();
      clearFilters();

      //clear query out of url without triggering re-render
      // window.history.replaceState(null, "", "/locate");
      //clear search history == important!
      history.search = null;

      getSearchResultsMap(
        "5f69d9b4b28c5e1f8f369c42",
        [],
        [],
        [],
        [],
        [],
        null,
        {
          search: "",
          state: {},
          key: "",
        },
        [],
        [],
        []
      );

      //if mobile, scroll to top of results.
      if (
        window.matchMedia("(pointer: coarse)").matches ||
        window.matchMedia("(hover: none)").matches
      ) {
        setTimeout(function () {
          const targetElement = document.querySelector(".num-of-results-text");
          if (targetElement)
            targetElement.scrollIntoView({ block: "start", inline: "start" });
        }, 500);
      } else {
        const targetResults = document.querySelector(".results");
        // if (targetResults) targetResults.scrollIntoView(true);

        const targetElement = document.querySelector(".restaurant-list");
        if (targetElement) targetElement.scrollTop = 0;
      }
    }
  };

  return (
    <FilteringStyles>
      <div className="filter-sort-bar__container">
        <div className="instructions">
          <h1 id="filter-bar" className="filter-sort-bar__instructions">
            Explore Amsterdam's best restaurants
          </h1>
          <p className="filter-sort-bar__instructions-2">
            Search from recommended eateries. Filter in new ways. Dine well, do
            good.
          </p>
          <div id="search-container">
            <SearchBar
              city={city}
              history={history}
              mobileSearch={false}
              clearAllChecks={clearAllChecks}
            />
          </div>
        </div>
        <div className="filters-header--mobile">
          <h3>Search and Filter</h3>
          <span
            className="close-filter-takeover"
            onClick={toggleFilterTakeover}
          >
            <CloseIcon />
          </span>
        </div>
        {mobile && (
          <>
            <p className="num-of-filters-text--mobile">
              {numOfFilters > 0 && (
                <span onClick={seeAll} className="close-icon">
                  <CloseIcon />
                </span>
              )}
              <span>{numOfFiltersText} applied</span>
            </p>
            <div
              id="search-container--mobile"
              className="search-container--mobile"
            >
              <SearchBar
                city={city}
                history={history}
                mobileSearch={true}
                toggleFilterTakeover={toggleFilterTakeover}
                clearAllChecks={clearAllChecks}
              />
            </div>
          </>
        )}
        <div className="filter-sort-bar">
          <div className="filter-dropdown">
            <h4 className="sustainable-dropdown-label dropdown-label">
              Rethink what makes restaurants great.
            </h4>
            <p className="dropdown-sublabel">
              Click to filter for eateries that highlight Conscious Dining
              values
            </p>
            <form
              className="dropdown"
              id={
                mobile ? "sustainable-dropdown--mobile" : "sustainable-dropdown"
              }
            >
              <div className="two-col-container">
                <div className="check-item check-item--values">
                  <input
                    className="sustainable-check"
                    type="checkbox"
                    id={mobile ? "Cuisine--mobile" : "Cuisine"}
                    name="Cuisine"
                    onChange={saveChanges}
                  />
                  <label
                    className="check-label--values"
                    htmlFor={mobile ? "Cuisine--mobile" : "Cuisine"}
                  >
                    Cuisine
                  </label>
                </div>
                <div className="check-item check-item--values">
                  <input
                    className="sustainable-check"
                    type="checkbox"
                    id={mobile ? "Sustainability--mobile" : "Sustainability"}
                    onChange={saveChanges}
                    name="Sustainability"
                  />
                  <label
                    className="check-label--values"
                    htmlFor={
                      mobile ? "Sustainability--mobile" : "Sustainability"
                    }
                  >
                    Sustainability
                  </label>
                </div>
                <div className="check-item check-item--values">
                  <input
                    className="sustainable-check"
                    type="checkbox"
                    id={mobile ? "Experience--mobile" : "Experience"}
                    name="Experience"
                    onChange={saveChanges}
                  />
                  <label
                    className="check-label--values"
                    htmlFor={mobile ? "Experience--mobile" : "Experience"}
                  >
                    Experience
                  </label>
                </div>
                <div className="check-item check-item--values">
                  <input
                    className="sustainable-check"
                    type="checkbox"
                    id={mobile ? "Diversity--mobile" : "Diversity"}
                    onChange={saveChanges}
                    name="Diversity"
                  />
                  <label
                    className="check-label--values"
                    htmlFor={mobile ? "Diversity--mobile" : "Diversity"}
                  >
                    Diversity
                  </label>
                </div>
                <div className="check-item check-item--values">
                  <input
                    className="sustainable-check"
                    type="checkbox"
                    id={mobile ? "Story--mobile" : "Story"}
                    onChange={saveChanges}
                    name="Story"
                  />
                  <label
                    className="check-label--values"
                    htmlFor={mobile ? "Story--mobile" : "Story"}
                  >
                    Story
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div className="filter-dropdown">
            <input
              type="checkbox"
              id={
                mobile
                  ? "lifestyle-filter-toggle--mobile"
                  : "lifestyle-filter-toggle"
              }
              className="toggle"
              defaultChecked
            />
            <label
              className="lifestyle-dropdown-label dropdown-label"
              htmlFor={
                mobile
                  ? "lifestyle-filter-toggle--mobile"
                  : "lifestyle-filter-toggle"
              }
            >
              <span className="label-text">
                <span className="label-title">Lifestyle</span>
                {lifestyleFilter?.length > 0 ? (
                  <span className="num-of-selected">
                    ({lifestyleFilter.length})
                  </span>
                ) : (
                  <span className="dropdown-examples">
                    Plant-based, Seafood-centric...
                  </span>
                )}
              </span>
              <span className="down-arrow">
                <DownArrow />
              </span>
            </label>
            <form
              className="dropdown"
              id={mobile ? "lifestyle-dropdown--mobile" : "lifestyle-dropdown"}
            >
              <div className="list">
                <div className="two-col-container">
                  <div className="check-item" key="Plant-focused">
                    <input
                      className="lifestyle-check"
                      id={mobile ? "Plant-focused--mobile" : "Plant-focused"}
                      type="checkbox"
                      name="Plant-focused"
                      onChange={saveChanges}
                    />
                    <label
                      className="check-label"
                      htmlFor={
                        mobile ? "Plant-focused--mobile" : "Plant-focused"
                      }
                    >
                      Plant-based
                    </label>
                  </div>
                  <div className="check-item" key="Seafood-centric">
                    <input
                      className="lifestyle-check"
                      id={
                        mobile ? "Seafood-centric--mobile" : "Seafood-centric"
                      }
                      type="checkbox"
                      onChange={saveChanges}
                      name="Seafood-centric"
                    />
                    <label
                      className="check-label"
                      htmlFor={
                        mobile ? "Seafood-centric--mobile" : "Seafood-centric"
                      }
                    >
                      Seafood-centric
                    </label>
                  </div>
                  <div className="check-item" key="Veg-friendly">
                    <input
                      className="lifestyle-check"
                      id={mobile ? "Veg-friendly--mobile" : "Veg-friendly"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Veg-friendly"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Veg-friendly--mobile" : "Veg-friendly"}
                    >
                      Veg-friendly
                    </label>
                  </div>
                  <div className="check-item" key="Meat-heavy">
                    <input
                      className="lifestyle-check"
                      id={mobile ? "Meat-heavy--mobile" : "Meat-heavy"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Meat-heavy"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Meat-heavy--mobile" : "Meat-heavy"}
                    >
                      Meat-heavy
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="filter-dropdown">
            <input
              type="checkbox"
              id={mobile ? "vibe-filter-toggle--mobile" : "vibe-filter-toggle"}
              className="toggle"
            />
            <label
              className="vibe-dropdown-label dropdown-label"
              htmlFor={
                mobile ? "vibe-filter-toggle--mobile" : "vibe-filter-toggle"
              }
            >
              <span className="label-text">
                <span className="label-title">Vibe</span>
                {vibeFilter?.length > 0 ? (
                  <span className="num-of-selected">({vibeFilter.length})</span>
                ) : (
                  <span className="dropdown-examples">Upscale, Beachy...</span>
                )}
              </span>
              <span className="down-arrow">
                <DownArrow />
              </span>
            </label>
            <form
              className="dropdown"
              id={mobile ? "vibe-dropdown--mobile" : "vibe-dropdown"}
            >
              <div className="list">
                <div className="two-col-container">
                  <div className="check-item" key="Minimal">
                    <input
                      className="vibe-check"
                      id={mobile ? "Minimal--mobile" : "Minimal"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Minimal"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Minimal--mobile" : "Minimal"}
                    >
                      Minimal
                    </label>
                  </div>
                  <div className="check-item" key="Traditional">
                    <input
                      className="vibe-check"
                      id={mobile ? "Traditional--mobile" : "Traditional"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Traditional"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Traditional--mobile" : "Traditional"}
                    >
                      Traditional
                    </label>
                  </div>
                  <div className="check-item" key="Cool">
                    <input
                      className="vibe-check"
                      id={mobile ? "Cool--mobile" : "Cool"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Cool"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Cool--mobile" : "Cool"}
                    >
                      Cool
                    </label>
                  </div>
                  <div className="check-item" key="Cozy">
                    <input
                      className="vibe-check"
                      id={mobile ? "Cozy--mobile" : "Cozy"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Cozy"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Cozy--mobile" : "Cozy"}
                    >
                      Cozy
                    </label>
                  </div>
                  <div className="check-item" key="Urban">
                    <input
                      className="vibe-check"
                      id={mobile ? "Urban--mobile" : "Urban"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Urban"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Urban--mobile" : "Urban"}
                    >
                      Urban
                    </label>
                  </div>
                  <div className="check-item" key="Bohemian">
                    <input
                      className="vibe-check"
                      id={mobile ? "Bohemian--mobile" : "Bohemian"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Bohemian"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Bohemian--mobile" : "Bohemian"}
                    >
                      Bohemian
                    </label>
                  </div>
                  <div className="check-item" key="Upscale">
                    <input
                      className="vibe-check"
                      id={mobile ? "Upscale--mobile" : "Upscale"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Upscale"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Upscale--mobile" : "Upscale"}
                    >
                      Upscale
                    </label>
                  </div>
                  <div className="check-item" key="Creative">
                    <input
                      className="vibe-check"
                      id={mobile ? "Creative--mobile" : "Creative"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Creative"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Creative--mobile" : "Creative"}
                    >
                      Creative
                    </label>
                  </div>
                  <div className="check-item" key="Lux">
                    <input
                      className="vibe-check"
                      id={mobile ? "Lux--mobile" : "Lux"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Lux"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Lux--mobile" : "Lux"}
                    >
                      Lux
                    </label>
                  </div>
                  <div className="check-item" key="Beachy">
                    <input
                      className="vibe-check"
                      id={mobile ? "Beachy--mobile" : "Beachy"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Beachy"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Beachy--mobile" : "Beachy"}
                    >
                      Beachy
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="filter-dropdown">
            <input
              type="checkbox"
              id={
                mobile
                  ? "cuisine-filter-toggle--mobile"
                  : "cuisine-filter-toggle"
              }
              className="toggle"
            />
            <label
              className="cuisine-dropdown-label dropdown-label"
              htmlFor={
                mobile
                  ? "cuisine-filter-toggle--mobile"
                  : "cuisine-filter-toggle"
              }
            >
              <span className="label-text">
                <span className="label-title">Cuisine</span>
                {cuisineFilter?.length > 0 ? (
                  <span className="num-of-selected">
                    ({cuisineFilter.length})
                  </span>
                ) : (
                  <span className="dropdown-examples">
                    Italian, Moroccan...
                  </span>
                )}{" "}
              </span>
              <span className="down-arrow">
                <DownArrow />
              </span>
            </label>
            <form
              className="dropdown"
              id={mobile ? "cuisine-dropdown--mobile" : "cuisine-dropdown"}
            >
              <div className="list">
                <div className="long-dropdown">
                  <p className="dropdown-subcategory">European</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Dutch">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Dutch--mobile" : "Dutch"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Dutch"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Dutch--mobile" : "Dutch"}
                      >
                        Dutch
                      </label>
                    </div>
                    <div className="check-item" key="Italian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Italian--mobile" : "Italian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Italian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Italian--mobile" : "Italian"}
                      >
                        Italian
                      </label>
                    </div>
                    <div className="check-item" key="Belgian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Belgian--mobile" : "Belgian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Belgian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Belgian--mobile" : "Belgian"}
                      >
                        Belgian
                      </label>
                    </div>
                    <div className="check-item" key="Nordic">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Nordic--mobile" : "Nordic"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Nordic"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Nordic--mobile" : "Nordic"}
                      >
                        Nordic
                      </label>
                    </div>
                    <div className="check-item" key="French">
                      <input
                        className="cuisine-check"
                        id={mobile ? "French--mobile" : "French"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="French"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "French--mobile" : "French"}
                      >
                        French
                      </label>
                    </div>
                    {/* <div className="check-item" key="Russian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Russian--mobile" : "Russian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Russian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Russian--mobile" : "Russian"}
                      >
                        Russian
                      </label>
                    </div> */}
                    <div className="check-item" key="German">
                      <input
                        className="cuisine-check"
                        id={mobile ? "German--mobile" : "German"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="German"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "German--mobile" : "German"}
                      >
                        German
                      </label>
                    </div>
                    <div className="check-item" key="Pan-European">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Pan-European--mobile" : "Pan-European"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Pan-European"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "Pan-European--mobile" : "Pan-European"
                        }
                      >
                        Pan-European
                      </label>
                    </div>
                    <div className="check-item" key="Spanish">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Spanish--mobile" : "Spanish"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Spanish"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Spanish--mobile" : "Spanish"}
                      >
                        Spanish
                      </label>
                    </div>
                    {/* <div className="check-item" key="Greek">
                  <input
                    className="cuisine-check"
                    id="Greek"
                    type="checkbox"
                    name="Greek"
                  />
                  <label className="check-label" htmlFor="Greek">
                    Greek
                  </label>
                </div> */}
                  </div>
                  <p className="dropdown-subcategory">Middle Eastern</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Israeli">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Israeli--mobile" : "Israeli"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Israeli"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Israeli--mobile" : "Israeli"}
                      >
                        Israeli
                      </label>
                    </div>
                    <div className="check-item" key="Syrian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Syrian--mobile" : "Syrian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Syrian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Syrian--mobile" : "Syrian"}
                      >
                        Syrian
                      </label>
                    </div>
                    <div className="check-item" key="Lebanese">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Lebanese--mobile" : "Lebanese"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Lebanese"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Lebanese--mobile" : "Lebanese"}
                      >
                        Lebanese
                      </label>
                    </div>
                    <div className="check-item" key="Pan-Middle Eastern">
                      <input
                        className="cuisine-check"
                        id={
                          mobile
                            ? "Pan-Middle Eastern--mobile"
                            : "Pan-Middle Eastern"
                        }
                        type="checkbox"
                        onChange={saveChanges}
                        name="Pan-Middle Eastern"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile
                            ? "Pan-Middle Eastern--mobile"
                            : "Pan-Middle Eastern"
                        }
                      >
                        Pan-Middle Eastern
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">Asian</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Indian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Indian--mobile" : "Indian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Indian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Indian--mobile" : "Indian"}
                      >
                        Indian
                      </label>
                    </div>
                    <div className="check-item" key="Indonesian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Indonesian--mobile" : "Indonesian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Indonesian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Indonesian--mobile" : "Indonesian"}
                      >
                        Indonesian
                      </label>
                    </div>
                    <div className="check-item" key="Japanese">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Japanese--mobile" : "Japanese"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Japanese"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Japanese--mobile" : "Japanese"}
                      >
                        Japanese
                      </label>
                    </div>
                    <div className="check-item" key="Thai">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Thai--mobile" : "Thai"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Thai"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Thai--mobile" : "Thai"}
                      >
                        Thai
                      </label>
                    </div>
                    <div className="check-item" key="Chinese">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Chinese--mobile" : "Chinese"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Chinese"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Chinese--mobile" : "Chinese"}
                      >
                        Chinese
                      </label>
                    </div>
                    <div className="check-item" key="Asian fusion">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Asian fusian--mobile" : "Asian fusian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Asian fusion"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "Asian fusian--mobile" : "Asian fusian"
                        }
                      >
                        Asian fusion
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">Pacific</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Australian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Australian--mobile" : "Australian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Australian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Australian--mobile" : "Australian"}
                      >
                        Australian
                      </label>
                    </div>
                    <div className="check-item" key="New Zealander">
                      <input
                        className="cuisine-check"
                        id={mobile ? "New-Zealander--mobile" : "New-Zealander"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="New Zealander"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "New-Zealander--mobile" : "New-Zealander"
                        }
                      >
                        New Zealander
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">Caribbean</p>
                  <div className="two-col-container">
                    {/* <div className="check-item" key="Jamaican">
                  <input
                    className="cuisine-check"
                    id="Jamaican"
                    type="checkbox"
                    name="Jamaican"
                  />
                  <label className="check-label" htmlFor="Jamaican">
                    Jamaican
                  </label>
                </div> */}
                    <div className="check-item" key="Surinamese">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Surinamese--mobile" : "Surinamese"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Surinamese"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Surinamese--mobile" : "Surinamese"}
                      >
                        Surinamese
                      </label>
                    </div>
                    <div className="check-item" key="Pan-Caribbean">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Pan-Caribbean--mobile" : "Pan-Caribbean"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Pan-Caribbean"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "Pan-Caribbean--mobile" : "Pan-Caribbean"
                        }
                      >
                        Pan-Caribbean
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">Latin</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Mexican">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Mexican--mobile" : "Mexican"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Mexican"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Mexican--mobile" : "Mexican"}
                      >
                        Mexican
                      </label>
                    </div>
                    <div className="check-item" key="Brazilian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Brazilian--mobile" : "Brazilian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Brazilian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Brazilian--mobile" : "Brazilian"}
                      >
                        Brazilian
                      </label>
                    </div>
                    <div className="check-item" key="Peruvian">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Peruvian--mobile" : "Peruvian"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Peruvian"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Peruvian--mobile" : "Peruvian"}
                      >
                        Peruvian
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">Anglo</p>
                  <div className="two-col-container">
                    <div className="check-item" key="British">
                      <input
                        className="cuisine-check"
                        id={mobile ? "British--mobile" : "British"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="British"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "British--mobile" : "British"}
                      >
                        British
                      </label>
                    </div>
                    <div className="check-item" key="American">
                      <input
                        className="cuisine-check"
                        id={mobile ? "American--mobile" : "American"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="American"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "American--mobile" : "American"}
                      >
                        American
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">African</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Moroccan">
                      <input
                        className="cuisine-check"
                        id={mobile ? "Moroccan--mobile" : "Moroccan"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Moroccan"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Moroccan--mobile" : "Moroccan"}
                      >
                        Moroccan
                      </label>
                    </div>
                    <div className="check-item" key="West African">
                      <input
                        className="cuisine-check"
                        id={mobile ? "West African--mobile" : "West African"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="West African"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "West African--mobile" : "West African"
                        }
                      >
                        West African
                      </label>
                    </div>
                    <div className="check-item" key="North African">
                      <input
                        className="cuisine-check"
                        id={mobile ? "North African--mobile" : "North African"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="North African"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "North African--mobile" : "North African"
                        }
                      >
                        North African
                      </label>
                    </div>
                    <div className="check-item" key="South African">
                      <input
                        className="cuisine-check"
                        id={mobile ? "South African--mobile" : "South African"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="South African"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "South African--mobile" : "South African"
                        }
                      >
                        South African
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">Other</p>
                  <div className="two-col-container">
                    <div className="check-item" key="International">
                      <input
                        className="cuisine-check"
                        id={mobile ? "International--mobile" : "International"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="International"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "International--mobile" : "International"
                        }
                      >
                        International
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="filter-dropdown">
            <input
              type="checkbox"
              id={mobile ? "meal-filter-toggle--mobile" : "meal-filter-toggle"}
              className="toggle"
            />
            <label
              className="meal-dropdown-label dropdown-label"
              htmlFor={
                mobile ? "meal-filter-toggle--mobile" : "meal-filter-toggle"
              }
            >
              <span className="label-text">
                <span className="label-title">Meal</span>
                {mealFilter?.length > 0 ? (
                  <span className="num-of-selected">({mealFilter.length})</span>
                ) : (
                  <span className="dropdown-examples">
                    Dinner, Smoothies/ juices...
                  </span>
                )}
              </span>
              <span className="down-arrow">
                <DownArrow />
              </span>
            </label>
            <form
              className="dropdown"
              id={mobile ? "meal-dropdown--mobile" : "meal-dropdown"}
            >
              <div className="list">
                <div className="two-col-container">
                  <div className="check-item" key="Coffee/ tea">
                    <input
                      className="meal-check"
                      id={mobile ? "Coffee/ tea--mobile" : "Coffee/ tea"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Coffee/ tea"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Coffee/ tea--mobile" : "Coffee/ tea"}
                    >
                      Coffee/<br></br> tea
                    </label>
                  </div>
                  <div className="check-item" key="Lunch">
                    <input
                      className="meal-check"
                      id={mobile ? "Lunch--mobile" : "Lunch"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Lunch"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Lunch--mobile" : "Lunch"}
                    >
                      Lunch
                    </label>
                  </div>
                  <div className="check-item" key="Smoothies/ juices">
                    <input
                      className="meal-check"
                      id={
                        mobile
                          ? "Smoothies/ juices--mobile"
                          : "Smoothies/ juices"
                      }
                      type="checkbox"
                      onChange={saveChanges}
                      name="Smoothies/ juices"
                    />
                    <label
                      className="check-label"
                      htmlFor={
                        mobile
                          ? "Smoothies/ juices--mobile"
                          : "Smoothies/ juices"
                      }
                    >
                      Smoothies/ juices
                    </label>
                  </div>
                  <div className="check-item" key="Drinks">
                    <input
                      className="meal-check"
                      id={mobile ? "Drinks--mobile" : "Drinks"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Drinks"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Drinks--mobile" : "Drinks"}
                    >
                      Drinks
                    </label>
                  </div>
                  <div className="check-item" key="Baked goods/ pastries">
                    <input
                      className="meal-check"
                      id={
                        mobile
                          ? "Baked goods/ pastries--mobile"
                          : "Baked goods/ pastries"
                      }
                      type="checkbox"
                      onChange={saveChanges}
                      name="Baked goods/ pastries"
                    />
                    <label
                      className="check-label"
                      htmlFor={
                        mobile
                          ? "Baked goods/ pastries--mobile"
                          : "Baked goods/ pastries"
                      }
                    >
                      Baked goods/ pastries
                    </label>
                  </div>
                  <div className="check-item" key="Dinner">
                    <input
                      className="meal-check"
                      id={mobile ? "Dinner--mobile" : "Dinner"}
                      type="checkbox"
                      onChange={saveChanges}
                      name="Dinner"
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "Dinner--mobile" : "Dinner"}
                    >
                      Dinner
                    </label>
                  </div>
                  <div className="check-item" key="Breakfast/ brunch">
                    <input
                      className="meal-check"
                      id={
                        mobile
                          ? "Breakfast/ brunch--mobile"
                          : "Breakfast/ brunch"
                      }
                      type="checkbox"
                      onChange={saveChanges}
                      name="Breakfast/ brunch"
                    />
                    <label
                      className="check-label"
                      htmlFor={
                        mobile
                          ? "Breakfast/ brunch--mobile"
                          : "Breakfast/ brunch"
                      }
                    >
                      Breakfast/ brunch
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="filter-dropdown">
            <input
              type="checkbox"
              id={
                mobile ? "dining-filter-toggle--mobile" : "dining-filter-toggle"
              }
              className="toggle"
            />
            <label
              className="dining-dropdown-label dropdown-label"
              htmlFor={
                mobile ? "dining-filter-toggle--mobile" : "dining-filter-toggle"
              }
            >
              <span className="label-text">
                <span className="label-title">Dining</span>
                {diningFilter?.length > 0 ? (
                  <span className="num-of-selected">
                    ({diningFilter.length})
                  </span>
                ) : (
                  <span className="dropdown-examples">
                    Outdoor seating, Takeaway...
                  </span>
                )}
              </span>
              <span className="down-arrow">
                <DownArrow />
              </span>
            </label>
            <form
              className="dropdown"
              id={mobile ? "dining-dropdown--mobile" : "dining-dropdown"}
            >
              <div className="list">
                <div className="two-col-container">
                  <div className="check-item">
                    <input
                      className="dining-check"
                      type="checkbox"
                      id={mobile ? "Indoor seating--mobile" : "Indoor seating"}
                      onChange={saveChanges}
                      name="Indoor seating"
                    />

                    <label
                      className="check-label"
                      htmlFor={
                        mobile ? "Indoor seating--mobile" : "Indoor seating"
                      }
                    >
                      Indoor seating
                    </label>
                  </div>
                  <div className="check-item">
                    <input
                      className="dining-check"
                      type="checkbox"
                      id={mobile ? "Takeaway--mobile" : "Takeaway"}
                      onChange={saveChanges}
                      name="Takeaway"
                    />

                    <label
                      className="check-label"
                      htmlFor={mobile ? "Takeaway--mobile" : "Takeaway"}
                    >
                      Takeaway
                    </label>
                  </div>
                  <div className="check-item">
                    <input
                      className="dining-check"
                      type="checkbox"
                      id={
                        mobile ? "Outdoor seating--mobile" : "Outdoor seating"
                      }
                      onChange={saveChanges}
                      name="Outdoor seating"
                    />

                    <label
                      className="check-label"
                      htmlFor={
                        mobile ? "Outdoor seating--mobile" : "Outdoor seating"
                      }
                    >
                      Outdoor seating
                    </label>
                  </div>
                  <div className="check-item">
                    <input
                      className="dining-check"
                      type="checkbox"
                      id={mobile ? "Delivery--mobile" : "Delivery"}
                      onChange={saveChanges}
                      name="Delivery"
                    />

                    <label
                      className="check-label"
                      htmlFor={mobile ? "Delivery--mobile" : "Delivery"}
                    >
                      Delivery
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="filter-dropdown">
            <input
              type="checkbox"
              id={
                mobile
                  ? "neighborhood-filter-toggle--mobile"
                  : "neighborhood-filter-toggle"
              }
              className="toggle"
            />
            <label
              className="neighborhood-dropdown-label dropdown-label"
              htmlFor={
                mobile
                  ? "neighborhood-filter-toggle--mobile"
                  : "neighborhood-filter-toggle"
              }
            >
              <span className="label-text">
                <span className="label-title">District</span>
                {neighborhoodFilter?.length > 0 ? (
                  <span className="num-of-selected">
                    ({neighborhoodFilter.length})
                  </span>
                ) : (
                  <span className="dropdown-examples">
                    Jordaan, Plantage...
                  </span>
                )}
              </span>
              <span className="down-arrow">
                <DownArrow />
              </span>
            </label>
            <form
              className="dropdown"
              id={
                mobile
                  ? "neighborhood-dropdown--mobile"
                  : "neighborhood-dropdown"
              }
            >
              <div className="list">
                <div className="long-dropdown">
                  <p className="dropdown-subcategory">North</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Noord">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Noord--mobile" : "Noord"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Noord"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Noord--mobile" : "Noord"}
                      >
                        Noord
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">Center</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Centrum">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Centrum--mobile" : "Centrum"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Centrum"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Centrum--mobile" : "Centrum"}
                      >
                        Centrum
                      </label>
                    </div>
                    <div className="check-item" key="Lower Grachten">
                      <input
                        className="neighborhood-check"
                        id={
                          mobile ? "Lower Grachten--mobile" : "Lower Grachten"
                        }
                        type="checkbox"
                        onChange={saveChanges}
                        name="Lower Grachten"
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile ? "Lower Grachten--mobile" : "Lower Grachten"
                        }
                      >
                        Lower Grachten
                      </label>
                    </div>
                    <div className="check-item" key="Jordaan">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Jordaan--mobile" : "Jordaan"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Jordaan"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Jordaan--mobile" : "Jordaan"}
                      >
                        Jordaan
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">West</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Westerpark">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Westerpark--mobile" : "Westerpark"}
                        type="checkbox"
                        onChange={saveChanges}
                        name="Westerpark"
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Westerpark--mobile" : "Westerpark"}
                      >
                        Westerpark
                      </label>
                    </div>
                    <div className="check-item" key="Oud West">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Oud West--mobile" : "Oud West"}
                        type="checkbox"
                        name="Oud West"
                        onChange={saveChanges}
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Oud West--mobile" : "Oud West"}
                      >
                        Oud West
                      </label>
                    </div>
                    <div className="check-item" key="Nieuw West">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Nieuw West--mobile" : "Nieuw West"}
                        type="checkbox"
                        name="Nieuw West"
                        onChange={saveChanges}
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Nieuw West--mobile" : "Nieuw West"}
                      >
                        Nieuw West
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">East</p>
                  <div className="two-col-container">
                    <div className="check-item" key="Oostelijke Eilanden">
                      <input
                        className="neighborhood-check"
                        id={
                          mobile
                            ? "Oostelijke Eilanden--mobile"
                            : "Oostelijke Eilanden"
                        }
                        type="checkbox"
                        name="Oostelijke Eilanden"
                        onChange={saveChanges}
                      />
                      <label
                        className="check-label"
                        htmlFor={
                          mobile
                            ? "Oostelijke Eilanden--mobile"
                            : "Oostelijke Eilanden"
                        }
                      >
                        Oostelijke Eilanden
                      </label>
                    </div>
                    <div className="check-item" key="Oost">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Oost--mobile" : "Oost"}
                        type="checkbox"
                        name="Oost"
                        onChange={saveChanges}
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Oost--mobile" : "Oost"}
                      >
                        Oost
                      </label>
                    </div>
                    <div className="check-item" key="Plantage">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Plantage--mobile" : "Plantage"}
                        type="checkbox"
                        name="Plantage"
                        onChange={saveChanges}
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Plantage--mobile" : "Plantage"}
                      >
                        Plantage
                      </label>
                    </div>
                  </div>
                  <p className="dropdown-subcategory">South</p>
                  <div className="two-col-container">
                    <div className="check-item" key="De Pijp">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "De Pijp--mobile" : "De Pijp"}
                        type="checkbox"
                        name="De Pijp"
                        onChange={saveChanges}
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "De Pijp--mobile" : "De Pijp"}
                      >
                        De Pijp
                      </label>
                    </div>
                    <div className="check-item" key="Zuid">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Zuid--mobile" : "Zuid"}
                        type="checkbox"
                        name="Zuid"
                        onChange={saveChanges}
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Zuid--mobile" : "Zuid"}
                      >
                        Zuid
                      </label>
                    </div>
                    <div className="check-item" key="Oud Zuid">
                      <input
                        className="neighborhood-check"
                        id={mobile ? "Oud Zuid--mobile" : "Oud Zuid"}
                        type="checkbox"
                        name="Oud Zuid"
                        onChange={saveChanges}
                      />
                      <label
                        className="check-label"
                        htmlFor={mobile ? "Oud Zuid--mobile" : "Oud Zuid"}
                      >
                        Oud Zuid
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="filter-dropdown">
            <input
              type="checkbox"
              id={
                mobile ? "price-filter-toggle--mobile" : "price-filter-toggle"
              }
              className="toggle"
            />
            <label
              className="price-dropdown-label dropdown-label"
              htmlFor={
                mobile ? "price-filter-toggle--mobile" : "price-filter-toggle"
              }
            >
              <span className="label-text">
                <span className="label-title">Price</span>
                {priceFilter?.length > 0 ? (
                  <span className="num-of-selected">
                    ({priceFilter.length})
                  </span>
                ) : (
                  <span className="dropdown-examples">€, €€, €€€...</span>
                )}
              </span>
              <span className="down-arrow">
                <DownArrow />
              </span>
            </label>
            <form
              className="dropdown"
              id={mobile ? "price-dropdown--mobile" : "price-dropdown"}
            >
              <div className="list">
                <div className="two-col-container">
                  <div className="check-item" key="€">
                    <input
                      className="price-check"
                      id={mobile ? "€--mobile" : "€"}
                      type="checkbox"
                      name="€"
                      onChange={saveChanges}
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "€--mobile" : "€"}
                    >
                      €
                    </label>
                  </div>
                  <div className="check-item" key="€€€">
                    <input
                      className="price-check"
                      id={mobile ? "€€€--mobile" : "€€€"}
                      type="checkbox"
                      name="€€€"
                      onChange={saveChanges}
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "€€€--mobile" : "€€€"}
                    >
                      €€€
                    </label>
                  </div>
                  <div className="check-item" key="€€">
                    <input
                      className="price-check"
                      id={mobile ? "€€--mobile" : "€€"}
                      type="checkbox"
                      name="€€"
                      onChange={saveChanges}
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "€€--mobile" : "€€"}
                    >
                      €€
                    </label>
                  </div>
                  <div className="check-item" key="€€€€">
                    <input
                      className="price-check"
                      id={mobile ? "€€€€--mobile" : "€€€€"}
                      type="checkbox"
                      name="€€€€"
                      onChange={saveChanges}
                    />
                    <label
                      className="check-label"
                      htmlFor={mobile ? "€€€€--mobile" : "€€€€"}
                    >
                      €€€€
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            className="done-filtering-btn--mobile"
            onClick={toggleFilterTakeover}
          >
            Show {restaurantList.length} result
            {restaurantList.length !== 1 && "s"}
          </div>
        </div>
      </div>
    </FilteringStyles>
  );
};

SearchSortFilter.propTypes = {
  restaurants: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  getSearchResultsMap: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  restaurants: state.restaurants,
});

export default connect(mapStateToProps, {
  setFilters,
  clearFilters,
  getSearchResultsMap,
})(SearchSortFilter);
